export default {
    getStyle: function(elapsed, total, fullscreen) {
      let percent;
      if(fullscreen === true) {
        percent = ((elapsed /  total) * 100).toFixed(2);
      } else {
        percent = ((elapsed / total) * 100).toFixed(2);
      }
      if(isNaN(percent) || percent < 0) {
        percent = 0;
      } else if(percent > 100) {
        percent = 100;
      }
      return {
        width: (percent) + '%'
      };
    }
};



/** WEBPACK FOOTER **
 ** ./modules/mixins/has_percentage_width.js
 **/